module.exports = "https://dev.stanwinstonschool.com/sw-logo.2ed06063585ef01126ef5930f24e16c7.svg";